import { orderBy as _orderBy } from 'lodash';

import {
    TimeType,
    LimitType,
    LimitData,
    Limits,
} from '@models/user/Limit';

import { LimitDto } from './dtos/LimitsDto';

const timeKeyMap = {
    [TimeType.Day]: 'day',
    [TimeType.Week]: 'week',
    [TimeType.Month]: 'month',
};

// Values which represent deleted limits
const DepositDeletedIndicator = 10000000000000000000000;
const TotalWagerDeletedIndicator = 50000000;

export function transformLimits(dto: LimitDto[]): Limits {
    const data: {
        [LimitType.Deposit]: LimitData;
        [LimitType.TotalWager]: LimitData;
        [LimitType.Loss]: LimitData;
        [LimitType.Session]: LimitData;
    } = {
        [LimitType.Deposit]: {
            day: null,
            week: null,
            month: null,
        },
        [LimitType.TotalWager]: {
            day: null,
            week: null,
            month: null,
        },
        [LimitType.Loss]: {
            day: null,
            week: null,
            month: null,
        },
        [LimitType.Session]: {
            day: null,
            week: null,
            month: null,
        },
    };
    _orderBy(dto, ['LimitStatus'], ['desc']).map((limitData) => {
        if ([LimitType.Deposit, LimitType.TotalWager, LimitType.Loss, LimitType.Session].includes(limitData.LimitType)) {
            const key = timeKeyMap[(limitData.Time)] as keyof LimitData;
            if (key) {
                if (data[limitData.LimitType][key]) {
                    // already had pending value. Set active as previous
                    data[limitData.LimitType][key]!.previousAmount = limitData.AmountValue;
                    data[limitData.LimitType][key]!.previousId = limitData.Id;
                    data[limitData.LimitType][key]!.limitRemaining = limitData.LimitRemaining;
                } else {
                    data[limitData.LimitType][key] = {
                        amount: limitData.AmountValue,
                        status: limitData.LimitStatus,
                        id: limitData.Id,
                        limitRemaining: limitData.LimitRemaining,
                    };
                }
                if (limitData.LimitType === LimitType.Deposit && limitData.AmountValue === DepositDeletedIndicator
                    || limitData.AmountValue === TotalWagerDeletedIndicator) {
                    data[limitData.LimitType][key]!.amount = 0;
                }
            }
        }
    });
    return data;
}
